import { ResetPasswordScreenNavigationProps } from "./types"
import React from "react"
import { useTheme } from "~/ui/styled"
import ResetPassword from "./reset-password-screen"
import { PageRoot } from "~screens/page-root"


const ResetPasswordScreen: React.FC<ResetPasswordScreenNavigationProps> = (props) => {
  const theme = useTheme()
  return (
    <PageRoot $background={theme.colors.primary}>
      <ResetPassword {...props} />
    </PageRoot>
  )
}

export default ResetPasswordScreen

